export default "__VITE_ASSET__a27efceb__"